<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>位置：</el-breadcrumb-item>
      <el-breadcrumb-item>营销管理</el-breadcrumb-item>
      <el-breadcrumb-item>留言板</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="conentBox" v-if="index==1">
      <el-row class="conentRow">
        <div>
          <el-col class="conentCol">
            <el-input placeholder="物品名称" v-model="data.item_name"></el-input>
          </el-col>
          <el-col class="conentCol">
            <el-date-picker
              v-model="value1"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-col>
          <el-col class="conentColSele">
            <el-select
              v-model="data.state"
              placeholder="状态"
              clearable
            >
              <el-option
                v-for="item in typeArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
          <el-col class="conentBtn" style="width: auto">
            <el-button type="primary" @click="chaBtns" >查询</el-button>
          </el-col>
        </div>
        <div class="addBtns">
          <div @click="addInfo">
            <img src="@/assets/add.png" alt="">
            <span>添加物品</span>
          </div>
        </div>
      </el-row>
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        :header-cell-style="tableHeaderColor"
        :cell-style="cellStyle"
      >
        <el-table-column prop="ProductID" label="物品图片">
          <template slot-scope="scope">
            <img style="width:6rem;height:6rem;" :src="scope.row.img" alt="">
          </template>
        </el-table-column>
        <el-table-column prop="item_name" label="物品名称"></el-table-column>
        <el-table-column prop="description" label="物品描述"></el-table-column>
        <el-table-column prop="createtime" label="发布时间"></el-table-column>

        <el-table-column prop="address" label="状态">
          <template  slot-scope="scope">
            <div class="cursor" v-if="scope.row.state=='1'">
              <img src="@/images/scenic/dl.png" alt />
              <span style="margin-left:9px">上线</span>
            </div>
            <div class="cursor"  v-if="scope.row.state=='2'" >
              <img src="@/images/scenic/dh.png" alt />
              <span style="margin-left:9px">下线</span>
            </div>
            <div class="cursor" v-if="scope.row.state=='3'">
              <img src="@/images/scenic/dl.png" alt />
              <span style="margin-left:9px">已领取</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="操作" width="200"    fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="addInfo(scope.row)"
              >详情查看</el-button
            >
            <el-button type="text" @click="lingqu(scope.row)" v-if="scope.row.state!='3'"
              >领取</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页开始 -->
      <div class="pagination">
        <span class="demonstration">共{{ total }}条记录，</span>
        <span class="demonstration">当前显示第{{ data.page }}页</span>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="data.page_size"
          :current-page="data.page"
          @current-change="currenchange"
        ></el-pagination>
      </div>
      <!-- 分页结束 -->
    </el-card>
    <el-dialog
      :close-on-click-modal="false"
      title="添加物品"
      :visible.sync="addProDialogVisible"
      :before-close="addProHandleClose"
      width="740px"
      center
    >
      <div class="info_dialogs">
        <el-form   :label-position="labelPosition"
          :model="ruleForm"
          ref="ruleForms"
          label-width="80px">
            <el-form-item label="物品名称:"> 
              <el-input placeholder="请输入" v-model="ruleForm.item_name"></el-input>
            </el-form-item>
            <el-form-item label="物品描述:"> 
              <el-input placeholder="请输入"  v-model="ruleForm.description"></el-input>
            </el-form-item>
            <el-form-item label="产品封面:"> 
              <div class="fengmian">
                <el-upload
                  class="avatar-uploader"
                  action="http://xwt.softykt.net/api/product/uploadInfoRemit"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :data="datas">
                  <img v-if="ruleForm.img" :src="ruleForm.img" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon">
                  </i>
                </el-upload>
                <span>
                  注：请上传1M一下的图片(此图片用于平台宣传，请认证对待)，支持png、jpg、jpeg
                </span>
              </div>
          </el-form-item>
          <el-form-item label="物品描述:"> 
            <el-radio-group v-model="ruleForm.state">
              <el-radio :label="1">上线</el-radio>
              <el-radio :label="2">下线</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div class="dialog_btns">
          <div  @click="clearclick">清空</div>
          <div @click="submit">确认添加</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="失物领取"
      :visible.sync="addProDialogVisible1"
      :before-close="addProHandleClose1"
      width="740px"
      center
    >
      <div class="info_dialogs">
        <el-form   :label-position="labelPosition"
          :model="ruleForm1"
          ref="ruleForms"
          label-width="80px">
            <div class="flexs">
            <el-form-item label="姓名:"> 
              <el-input  placeholder="请输入" v-model="ruleForm1.username"></el-input>
            </el-form-item>
            <el-form-item label="联系电话:"> 
              <el-input  placeholder="请输入" v-model="ruleForm1.mobile"></el-input>
            </el-form-item>
          </div>
          <el-form-item label="身份证:"> 
              <el-input  placeholder="请输入" v-model="ruleForm1.idcard"></el-input>
          </el-form-item>
          <el-form-item label="内容:">
            <el-input  type="textarea" v-model="ruleForm1.remark"></el-input>
          </el-form-item>
          <el-form-item label="物品描述:"> 
            <el-radio-group v-model="ruleForm1.state">
              <el-radio :label="1">上线</el-radio>
              <el-radio :label="2">下线</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div class="dialog_btns">
          <div @click="clears">清空</div>
          <div @click="addLingqu">领取</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { lostInfoList , addLostInfo , addLostUserInfo }  from '@/request/scenic.js'
import {Message, MessageBox } from 'element-ui'
export default {
  data() {
    return {
      addProDialogVisible1:false,
      value1:'',
      datas:{
        token: window.sessionStorage.getItem("Token"),
      },
      labelPosition: "right",
      ruleForm:{
        token: window.sessionStorage.getItem("Token"),
        item_name:'',
        description:'',
        img:'',
        state:1,
        id:''
      },
      addProDialogVisible: false,
      index: 1,
      data: {
        token: window.sessionStorage.getItem("Token"),
        item_name:'',
        starttime:'',
        endtime:'',
        state:'',
        page: 1,
        page_size: 8,
      },
      name: "",
      tableData:[],
      typeArr:[
        {
          value:'1',
          label:'上线'
        },
        {
          value:'2',
          label:'下线'
        },
        {
          value:'3',
          label:'已领取'
        }
      ],
      total:0,
      ruleForm1:{
        token: window.sessionStorage.getItem("Token"),
        id:'',
        username:'',
        mobile:'',
        idcard:'',
        remark:'',
        state:1
      }
    };
  },
  created(){
    this.getList()
  },
  methods: {
    chaBtns(){
      if(this.value1){
        this.data.starttime = this.value1[0]
        this.data.endtime = this.value1[1]
      }else{
        this.data.starttime = ''
        this.data.endtime = ''
      }
      this.data.page  = 1
      this.getList()
    },
    clearclick(){
      this.ruleForm.item_name = ''
      this.ruleForm.description = ''
      this.ruleForm.img = ''
    },
    clears(){
      this.ruleForm1.username = ''
      this.ruleForm1.mobile = ''
      this.ruleForm1.idcard = ''
      this.ruleForm1.remark = ''
    },
    addLingqu(){
      if(this.ruleForm1.username==''){
        Message.error('请输入姓名')
        return false
      }
      if(this.ruleForm1.mobile==''){
        Message.error('请输入手机号')
        return false
      }
      if(this.ruleForm1.idcard==''){
        Message.error('请输入身份证号')
        return false
      }
      if(this.ruleForm1.remark==''){
        Message.error('请输入备注')
        return false
      }
      addLostUserInfo(this.ruleForm1).then(res=>{
        if(res.data.rcode==200){
          Message.success('领取失物成功')
          this.data.page = 1
          this.getList()
          this.addProDialogVisible1 = false;
          this.ruleForm1 = {
            token: window.sessionStorage.getItem("Token"),
            id:'',
            username:'',
            mobile:'',
            idcard:'',
            remark:'',
            state:1
          }
        }else{
          Message.error(res.data.msg)
        }
      })
    },
    lingqu(row){
      this.ruleForm1.id = row.id
      this.addProDialogVisible1 = true
    },
    submit(){
      if(this.ruleForm.item_name==''){
        Message.error('请输入物品名称')
        return false
      }
      if(this.ruleForm.description==''){
        Message.error('请输入物品描述')
        return false
      }
      if(this.ruleForm.img==''){
        Message.error('请上传图片')
        return false
      }
      addLostInfo(this.ruleForm).then(res=>{
        if(res.data.rcode==200){
          Message.success('添加失物成功')
          this.data.page = 1
          this.getList()
          this.addProDialogVisible = false;
          this.ruleForm={
            token: window.sessionStorage.getItem("Token"),
            item_name:'',
            description:'',
            img:'',
            state:1,
            id:''
          }
        }else{
          Message.error(res.data.msg)
        }
      })
    },
    handleAvatarSuccess(res, file) {
      this.ruleForm.img = res.result
    },
    addInfo(row){
      if(row.id){
        this.ruleForm.item_name = row.item_name
        this.ruleForm.description = row.description
        this.ruleForm.img = row.img
        this.ruleForm.state = row.state
        this.ruleForm.id = row.id
      }
      this.addProDialogVisible = true
    },
    currenchange(e){
      this.data.page = e
      this.getList()
    },
    getList(){
      lostInfoList(this.data).then(res=>{
        if(res.data.rcode==200){
          this.tableData = res.data.result.data
          this.total = res.data.result.total
        }
      })
    },
    addProHandleClose() {
      this.addProDialogVisible = false;
      this.ruleForm={
        token: window.sessionStorage.getItem("Token"),
        item_name:'',
        description:'',
        img:'',
        state:1,
        id:''
      }
    },
    addProHandleClose1() {
      this.ruleForm1 = {
        token: window.sessionStorage.getItem("Token"),
        id:'',
        username:'',
        mobile:'',
        idcard:'',
        remark:'',
        state:1
      }
      this.addProDialogVisible1 = false;
    },
    tabClick(e){
      if(this.index==e){
        return false
      }
      this.index = e
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex,
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex,
      });
    },
  },
};
</script>
<style lang="less" scoped>
 .fengmian{
    display: flex;
    >span{
      margin-left: 2rem;
      color: #FF4D4F;
      font-size: 1.4rem;
      line-height: 1.4rem;
      margin-top: auto;
      display: block;
    }
  }
 .avatar-uploader{
    width: 23rem;
    height: 13rem;
    border-radius: 0.8rem;
    border: 1px solid #E5E5EA;
    img{
      width: 100%;
      height: 100%;
    }
    ::v-deep .el-upload{
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .el-icon-plus{
        font-size: 2.8rem;
      }
    }
  }
  .dialog_btns{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 4rem;
  >div{
    width: 10rem;
    height: 4rem;
    color: #fff;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0.4rem;
    &:nth-child(1){
      margin-right: 2rem;
      background: #D9D9D9;
    }
    &:nth-child(2){
      background: #246deb;
    }
  }
}
.info_dialogs {
  padding: 2rem;
  box-sizing: border-box;
  border-top: 1px solid #e5e5ea;
  ::v-deep .el-select{
    width: 100%;
  }
  .flexs{
    display: flex;
    justify-content: space-between;
    ::v-deep .el-input{
      width: 24rem;
    }
  }
  ::v-deep .el-textarea{
    height: 8rem;
  }
  ::v-deep .el-textarea__inner{
    height: 100% !important;
    resize: none; 
    width: 100%;
  }

}
.conentBox {
  margin-top: 17px;
  .conentRow {
    margin: 20px 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    > div:nth-child(1) {
      // width: 50%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .conentCol {
        width: 32rem;
        position: relative;
        margin-right: 10px;
        margin-bottom: 10px;
        /deep/.el-input {
          width: 100%;
        }
      }
      .conentColSele {
        margin-right: 10px;
        margin-left: 3rem;
        margin-bottom: 10px;
        width: 32rem;
        position: relative;
        /deep/.el-select {
          width: 100%;
        }
      }
      .conentBtn {
        margin-bottom: 10px;
        // width: 120px;
        .el-button {
          width: 100px;
          // width: 84%;
          background: #246deb;
          border-radius: 4px;
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          color: #ffffff;
        }
      }
    }
    > div:nth-child(2) {
      // width: 50%;
      display: flex;
      justify-content: flex-end;
      margin-bottom: 10px;
      margin-left: auto;
      .scenicBtnDel {
        .el-button {
          width: 92px;
          background: #ffffff;
          border: 1px solid #ff4d4f;
          border-radius: 4px;
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          color: #ff4d4f;
          box-sizing: border-box;
        }
      }
      .scenicBtnPx {
        margin: 0 20px;
        .el-button {
          background: #ffffff;
          border: 1px solid #246deb;
          border-radius: 4px;
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          /* identical to box height */
          box-sizing: border-box;
          color: #246deb;
        }
      }
      .scenicBtn {
        .el-button {
          width: 120px;
          background: #ffffff;
          border: 1px solid #246deb;
          border-radius: 4px;
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          box-sizing: border-box;
          color: #246deb;
        }
      }
    }
  }
}
.info_tabs {
  display: flex;
  align-items: center;
  margin-top: 2rem;
  > div {
    margin-right: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 11.6rem;
    height: 4rem;
    border-radius: 0.4rem;
    color: #fff;
    font-size: 1.4rem;
    background: #d9d9d9;
    cursor: pointer;
  }
  .tabs_active {
    background: #246deb;
  }
}
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 42px auto;
  position: relative;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}
.addBtns{
  >div{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 12rem;
    height: 4rem;
    border-radius: 0.4rem;
    border: 1px solid #246DEB;
    color: #246DEB;
    cursor: pointer;
    img{
      width: 1.4rem;
      height: 1.4rem;
      margin-right: 1rem;
    }
  }
}
</style>